import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-ai-function-dialog',
  templateUrl: './ai-function-dialog.component.html',
  styleUrls: ['./ai-function-dialog.component.scss']
})
export class AiFunctionDialogComponent implements OnInit {
  public functionData: string = '';
  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    private dialogRef: MatDialogRef<AiFunctionDialogComponent>,
  ) {
    this.functionData = data.function === 'null' ? '' : data.function;
  }

  ngOnInit(): void {
  }

  close(): void {
    this.dialogRef.close();
  }
  save(): void {
    const result = this.functionData && this.functionData.length > 0 ? this.functionData : 'null';
    this.dialogRef.close(result);
  }
}
